export default function renderTwyneMulti({ url, pubid, srcid, istest }) {
  return `<script type="text/javascript" id="twyne-embed" class="twyne-embed">
  window.userEnroll.twyne.init({
    placement: {
      pid: '${pubid}',
      sid: '${srcid}',
      embedUrlOverride: '${url}',
      externalgroup: '{pe_key}',
      subid1: '{pid}',
      subid2: '{sid1}',
    },
    consumer: {
      first: '{firstName_jsescape}',
      last: '{lastName_jsescape}',
      email: '{email_jsescape}',
      address1: '{address1_jsescape}',
      address2: '{address2_jsescape}',
      city: '{city_jsescape}',
      gender: '{gender_urlencoded}',
      state: '{state_urlencoded}',
      zip: '{zip_urlencoded}',
      country: 'US',
      phone: '{phone}',
      dob: '{dob_slashes_mmddyyyy_urlencoded}',
      istest: '${istest ? 'y' : 'n'}',
      optout: '{optout}',
      checkers: '{checkers}',
      cf_hired: '{cf_hired}',
      cf_new_date: '{cf_new_date}',
      cf_last_date: '{cf_last_date}',
      cf_civil_state: '{cf_civil_state}',
      cf_genres: '{cf_genres}',
      cf_music_bands: '{cf_music_bands}',
      cf_married: '{cf_married}',
      cf_email_domain: '{cf_email_domain}',
      cf_age: '{cf_age}',
      cf_car_brand: '{cf_car_brand}',
      cf_gb_user: '{cf_gb_user}',
      cf_gb_repository: '{cf_gb_repository}',
      cf_size: '{cf_size}',
      cf_query: '{cf_query}',
      cf_car_make: '{cf_car_make}',
      cf_car_model: '{cf_car_model}',
      cf_car_trim: '{cf_car_trim}',
      cf_car_year: '{cf_car_year}',
      cf_password: '{cf_password}',
      cf_planetary_ages: '{cf_planetary_ages}',
      cf_pekey: '{cf_pekey}',
    },
  })
</script>`
}
